export default {
  namespaced: true,
  state: {
    result: null,
    modalState: false,
    modalType: null,
    modalProps: null,
  },
  getters: {
    modalState(state) {
      return state.modalState
    },
    modalType(state) {
      return state.modalType
    },
    modalProps(state) {
      return state.modalProps
    },
    modalResult(state) {
      return state.result
    },
  },
  mutations: {
    modalType_successOpen(state, props) {
      state.modalType = 'success'
      state.modalState = true
      state.modalProps = props
    },
    modalType_errorOpen(state, props) {
      state.modalType = 'error'
      state.modalState = true
      state.modalProps = props
    },
    modalType_noFormatOpen(state, props) {
      state.modalType = 'noFormat'
      state.modalState = true
      state.modalProps = props
    },
    modalType_reviewsOpen(state, props) {
      state.modalType = 'reviews'
      state.modalState = true
      state.modalProps = props
    },
    modalType_certificatesOpen(state, props) {
      state.modalType = 'certificates'
      state.modalState = true
      state.modalProps = props
    },
    modalType_contactsOpen(state, props) {
      state.modalType = 'contacts'
      state.modalState = true
      state.modalProps = props
    },
    modalType_eventsVideoOpen(state, props) {
      state.modalType = 'eventsVideo'
      state.modalState = true
      state.modalProps = props
    },
    modalType_collabOpen(state, props) {
      state.modalType = 'collab'
      state.modalState = true
      state.modalProps = props
    },
    modalType_fullVersionOpen(state, props) {
      state.modalType = 'fullVersion'
      state.modalState = true
      state.modalProps = props
    },
    modalType_requestOpen(state, props) {
      state.modalType = 'request'
      state.modalState = true
      state.modalProps = props
    },
    modalType_addStaffOpen(state, props) {
      state.modalType = 'addStaff'
      state.modalState = true
      state.modalProps = props
    },
    modalType_deleteStaffOpen(state, props) {
      state.modalType = 'deleteStaff'
      state.modalState = true
      state.modalProps = props
    },
    modalType_editStaffOpen(state, props) {
      state.modalType = 'editStaff'
      state.modalState = true
      state.modalProps = props
    },
    modalType_inviteOpen(state, props) {
      state.modalType = 'invite'
      state.modalState = true
      state.modalProps = props
    },
    modalType_inviteSuccessOpen(state, props) {
      state.modalType = 'inviteSuccess'
      state.modalState = true
      state.modalProps = props
    },
    modalType_lkFilterOpen(state, props) {
      state.modalType = 'lkFilter'
      state.modalState = true
      state.modalProps = props
    },
    modalType_competenciesOpen(state, props) {
      state.modalType = 'competencies'
      state.modalState = true
      state.modalProps = props
    },
    modalType_trainingOpen(state, props) {
      state.modalType = 'training'
      state.modalState = true
      state.modalProps = props
    },
    modalType_lkSuccessOpen(state, props) {
      state.modalType = 'lkSuccess'
      state.modalState = true
      state.modalProps = props
    },
    modalType_lkErrorOpen(state, props) {
      state.modalType = 'lkError'
      state.modalState = true
      state.modalProps = props
    },
    modalType_refuseLeadOpen(state, props) {
      state.modalType = 'refuseLead'
      state.modalState = true
      state.modalProps = props
    },
    modalType_attachContactOpen(state, props) {
      state.modalType = 'attachContact'
      state.modalState = true
      state.modalProps = props
    },
    modalType_changeDateOpen(state, props) {
      state.modalType = 'changeDate'
      state.modalState = true
      state.modalProps = props
    },
    modalType_deleteContactOpen(state, props) {
      state.modalType = 'deleteContact'
      state.modalState = true
      state.modalProps = props
    },
    modalType_requestContactOpen(state, props) {
      state.modalType = 'requestContact'
      state.modalState = true
      state.modalProps = props
    },
    modalType_lkMobileNotifyOpen(state, props) {
      state.modalType = 'lkMobileNotify'
      state.modalState = true
      state.modalProps = props
    },
    modalType_lkMobileCalendarOpen(state, props) {
      state.modalType = 'lkMobileCalendar'
      state.modalState = true
      state.modalProps = props
    },
    modalType_actRequestOpen(state, props) {
      state.modalType = 'actRequest'
      state.modalState = true
      state.modalProps = props
    },
    modalType_missingDataOpen(state, props) {
      state.modalType = 'missingData'
      state.modalState = true
      state.modalProps = props
    },
    modalType_myOrganisationCompetenciesOpen(state, props) {
      state.modalType = 'myOrganisationCompetencies'
      state.modalState = true
      state.modalProps = props
    },
    modalType_lkAcceptLeadModal(state, props) {
      state.modalType = 'acceptLeadModal'
      state.modalState = true
      state.modalProps = props
    },
    modalType_lkWinLeadModalOpen(state, props) {
      state.modalType = 'winLeadModal'
      state.modalState = true
      state.modalProps = props
    },
    modalType_lkHowWorkWithLeads(state, props) {
      state.modalType = 'howWorkWithLeads'
      state.modalState = true
      state.modalProps = props
    },
    modalType_consentOpen(state, props) {
      state.result = null
      state.modalType = 'consent'
      state.modalState = true
      state.modalProps = props
    },
    modalType_ironPartnerOpen(state, props) {
      state.modalType = 'ironPartnerModal'
      state.modalState = true
      state.modalProps = props
    },
    setModalResult(state, value) {
      state.result = value
    },
    modalClose(state) {
      state.modalType = null
      state.modalState = false
    },
  },
  actions: {
    modalType_lkAcceptLeadModal(store, props) {
      store.commit('modalType_lkAcceptLeadModal', props)
    },
    modalType_successOpen(store, props) {
      store.commit('modalType_successOpen', props)
    },
    modalType_errorOpen(store, props) {
      store.commit('modalType_errorOpen', props)
    },
    modalType_noFormatOpen(store, props) {
      store.commit('modalType_noFormatOpen', props)
    },
    modalType_reviewsOpen(store, props) {
      store.commit('modalType_reviewsOpen', props)
    },
    modalType_certificatesOpen(store, props) {
      store.commit('modalType_certificatesOpen', props)
    },
    modalType_contactsOpen(store, props) {
      store.commit('modalType_contactsOpen', props)
    },
    modalType_eventsVideoOpen(store, props) {
      store.commit('modalType_eventsVideoOpen', props)
    },
    modalType_collabOpen(store, props) {
      store.commit('modalType_collabOpen', props)
    },
    modalType_fullVersionOpen(store, props) {
      store.commit('modalType_fullVersionOpen', props)
    },
    modalType_requestOpen(store, props) {
      store.commit('modalType_requestOpen', props)
    },
    modalType_addStaffOpen(store, props) {
      store.commit('modalType_addStaffOpen', props)
    },
    modalType_deleteStaffOpen(store, props) {
      store.commit('modalType_deleteStaffOpen', props)
    },
    modalType_editStaffOpen(store, props) {
      store.commit('modalType_editStaffOpen', props)
    },
    modalType_inviteOpen(store, props) {
      store.commit('modalType_inviteOpen', props)
    },
    modalType_inviteSuccessOpen(store, props) {
      store.commit('modalType_inviteSuccessOpen', props)
    },
    modalType_lkFilterOpen(store, props) {
      store.commit('modalType_lkFilterOpen', props)
    },
    modalType_competenciesOpen(store, props) {
      store.commit('modalType_competenciesOpen', props)
    },
    modalType_trainingOpen(store, props) {
      store.commit('modalType_trainingOpen', props)
    },
    modalType_lkSuccessOpen(store, props) {
      store.commit('modalType_lkSuccessOpen', props)
    },
    modalType_lkErrorOpen(store, props) {
      store.commit('modalType_lkErrorOpen', props)
    },
    modalType_refuseLeadOpen(store, props) {
      store.commit('modalType_refuseLeadOpen', props)
    },
    modalType_attachContactOpen(store, props) {
      store.commit('modalType_attachContactOpen', props)
    },
    modalType_changeDateOpen(store, props) {
      store.commit('modalType_changeDateOpen', props)
    },
    modalType_deleteContactOpen(store, props) {
      store.commit('modalType_deleteContactOpen', props)
    },
    modalType_requestContactOpen(store, props) {
      store.commit('modalType_requestContactOpen', props)
    },
    modalType_lkMobileNotifyOpen(store, props) {
      store.commit('modalType_lkMobileNotifyOpen', props)
    },
    modalType_lkMobileCalendarOpen(store, props) {
      store.commit('modalType_lkMobileCalendarOpen', props)
    },
    modalType_actRequestOpen(store, props) {
      store.commit('modalType_actRequestOpen', props)
    },
    modalType_missingDataOpen(store, props) {
      store.commit('modalType_missingDataOpen', props)
    },
    modalType_myOrganisationCompetenciesOpen({ commit }, props) {
      commit('modalType_myOrganisationCompetenciesOpen', props)
    },
    modalType_lkWinLeadModalOpen({ commit }, props) {
      commit('modalType_lkWinLeadModalOpen', props)
    },
    modalType_lkHowWorkWithLeads({ commit }, props) {
      commit('modalType_lkHowWorkWithLeads', props)
    },
    modalType_consentOpen({ commit }, props = {}) {
      commit('modalType_consentOpen', props)
    },
    modalType_ironPartnerOpen({ commit }, props = {}) {
      commit('modalType_ironPartnerOpen', props)
    },
    modalClose({ commit }, result) {
      commit('modalClose')
      if (result) commit('setModalResult', result)
    },
  },
}



// WEBPACK FOOTER //
// ./src/legacy/store/modules/modal.js